import { render } from "./Slides.vue?vue&type=template&id=b35c3052&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"

import "./Slides.vue?vue&type=style&index=0&id=b35c3052&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35c3052"]])

export default __exports__